var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Inject } from "../../di/inject";
import { Validator } from "./validator";
var ValidatorBuilder = /** @class */ (function () {
    function ValidatorBuilder(_field) {
        this._field = _field;
        this.customValidators = [];
    }
    Object.defineProperty(ValidatorBuilder.prototype, "field", {
        get: function () {
            return this._field;
        },
        enumerable: false,
        configurable: true
    });
    ValidatorBuilder.prototype.isRequired = function () {
        this.required = this.validator.isNotEmpty.bind(this.validator, this.field);
        return this;
    };
    ValidatorBuilder.prototype.isTooLong = function (maxLength) {
        this.tooLong = this.validator.isTooLong.bind(this.validator, this.field, maxLength);
        return this;
    };
    ValidatorBuilder.prototype.isTooShort = function (minLength) {
        this.tooShort = this.validator.isTooShort.bind(this.validator, this.field, minLength);
        return this;
    };
    ValidatorBuilder.prototype.isEmail = function () {
        this.email = this.validator.isEmail.bind(this.validator, this.field);
        return this;
    };
    ValidatorBuilder.prototype.isNumber = function () {
        this.number = this.validator.isNumber.bind(this.validator, this.field);
        return this;
    };
    ValidatorBuilder.prototype.isPhone = function () {
        this.phone = this.validator.isPhone.bind(this.validator, this.field);
        return this;
    };
    ValidatorBuilder.prototype.matches = function (length) {
        this.matchLength = this.validator.matchLength.bind(this.validator, this.field, length);
        return this;
    };
    ValidatorBuilder.prototype.custom = function (validator) {
        this.customValidators.push(validator.bind(this.validator, this.field));
        return this;
    };
    ValidatorBuilder.prototype.validate = function () {
        var _this = this;
        if (this.required && !this.required(this.field)) {
            return false;
        }
        if (this.email && !this.email(this.field)) {
            return false;
        }
        if (this.tooLong && this.tooLong(this.field)) {
            return false;
        }
        if (this.tooShort && this.tooShort(this.field)) {
            return false;
        }
        if (this.number && !this.number(this.field)) {
            return false;
        }
        if (this.matchLength && !this.matchLength(this.field)) {
            return false;
        }
        if (this.phone && !this.phone(this.field)) {
            return false;
        }
        if (this.customValidators.length) {
            var isValid = this.customValidators.every(function (custom) { return custom(_this.field); });
            if (!isValid) {
                return false;
            }
        }
        return true;
    };
    __decorate([
        Inject(),
        __metadata("design:type", Validator)
    ], ValidatorBuilder.prototype, "validator", void 0);
    return ValidatorBuilder;
}());
export { ValidatorBuilder };
//# sourceMappingURL=validator-builder.js.map